export default __webpack_public_path__ + "static/media/gmail.e63054e4.svg";